import { isExperimentEnabled } from '../selectors/experiments-selectors';
import { EXPERIMENT_ENABLE_RICH_CONTENT_SCHEMA_CLIENT } from '@wix/communities-forum-client-commons';

export const FETCH_FORUM_DATA_REQUEST = 'forumData/FETCH_REQUEST';
export const FETCH_FORUM_DATA_SUCCESS = 'forumData/FETCH_SUCCESS';
export const FETCH_FORUM_DATA_FAILURE = 'forumData/FETCH_FAILURE';

const fetchForumDataRequest = () => ({ type: FETCH_FORUM_DATA_REQUEST });
const fetchForumDataSuccess = (payload) => ({ type: FETCH_FORUM_DATA_SUCCESS, payload });
const fetchForumDataFailure = () => ({ type: FETCH_FORUM_DATA_FAILURE });

export function fetchForumData(promise) {
  return (dispatch, getState, { request }) => {
    const isRichContentSchemaEnabled = isExperimentEnabled(
      getState(),
      EXPERIMENT_ENABLE_RICH_CONTENT_SCHEMA_CLIENT,
    );
    dispatch(fetchForumDataRequest());

    promise =
      promise || request(`/forums/this${isRichContentSchemaEnabled ? '?useRichContent=true' : ''}`);
    return promise
      .then((forumData) => dispatch(fetchForumDataSuccess(forumData)))
      .catch(() => dispatch(fetchForumDataFailure()))
      .then(() => promise);
  };
}
